import Component from '../core/Component'

export default class MenuOpener extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const nav = Component.getFromElement('mobile-navigation')

        if (nav) {
            event.preventDefault()
            nav.toggle()
        }
    }

}